export default __webpack_public_path__ + "static/media/game-logo.0ebcca5f.svg";